import { useState } from 'react';

export const ASSIGNED_TO_ME_QUERY_KEY = 'assignedToMe';

export const useAssignedToMeState = () => {
  const [assignedToMe, setAssigned] = useState(
    localStorage.getItem(ASSIGNED_TO_ME_QUERY_KEY) === 'true',
  );

  const setAssignedToMe = (isAssignedToMe: boolean) => {
    localStorage.setItem(ASSIGNED_TO_ME_QUERY_KEY, `${isAssignedToMe}`);
    setAssigned(isAssignedToMe);
  };

  return {
    assignedToMe,
    setAssignedToMe,
  };
};
